import { CATEGORIES } from "../../../domain/influencerService";

const categoryClassMap = {
  [CATEGORIES.QUOTE]: "chipQuote",
  [CATEGORIES.DOODLE]: "chipDoodle",
  [CATEGORIES.CUSTOM]: "chipCustom",
};

export const categoryChipClass = (category, styles) =>
  styles[categoryClassMap[category]] ?? "";
